import React, { Fragment, useEffect, useState } from "react";
import DualListBox from "../../core/BaseComponents/CustomDualList/DualListBox";
import BasicModal from "../../core/BaseComponents/Modal";
import RailConfigPreview from "./RailConfigPreview";

function HotelServices(props) {
  const { tabs, masterHotelServiceList, onSubmitHandler, editPublishUnPublish,
          railName, roomTypes, selectedChannelForYouFullObject, onResetHandler, selectedUtilityFullObject,
          selectedPartnerFullObject, selectedHotelChannelFullObject, setSelectedHotelServiceFullObject,
          onResetHotelService, defaultValue, setHotelServiceData, tabChangeHandler, setPayloadHotelService } = props;

  const [preview, setPreview] = useState(false);
  const [initialSelected, setInitialSelected] = useState([]);
  const [hotelServiceList, setHotelServiceList] = useState([])

  const [selectedHotelService, setSelectedHotelService] = useState([]);
  const [previewHotelService, setPreviewHotelService] = useState([]);

  const [selectedHotelServiceMaxLengthError, setSelectedHotelServiceMaxLengthError] = useState("");

  useEffect(() => {
    if (Array.isArray(defaultValue) && defaultValue.length) {
      const defaultSids = defaultValue.map((item) => item.hotelServiceId);
      const defaultHotelsService = masterHotelServiceList?.filter((HotelsServiceData) =>defaultSids.includes(HotelsServiceData?.id))
      const sequenceData = defaultHotelsService?.map((HotelsService)=>({...HotelsService, sequenceNo: defaultValue?.find(def=>def?.hotelServiceId === HotelsService?.id)?.sequenceNo}))
      const sortedData = sequenceData?.sort((a,b)=>a.sequenceNo - b.sequenceNo)
      setSelectedHotelServiceFullObject(sortedData)
      setPreviewHotelService(sortedData)
      setInitialSelected(sortedData);
      setHotelServiceList(
        masterHotelServiceList?.filter(
          (partnerData) => !defaultSids.includes(partnerData?.id)
        )
      );
      // setSelectedPartners({partnerIds: defaultSids})
    } else {
      setHotelServiceList(masterHotelServiceList);
      setSelectedHotelServiceFullObject([])
      setSelectedHotelService([])
      setPreviewHotelService([])
      setInitialSelected([]);
    }
  }, [defaultValue, masterHotelServiceList]);

  useEffect(() => {
    if (defaultValue?.length) {
      // localStorage.setItem(
      //   "hotelServicesPayload",
      //   JSON.stringify({ hotelServices: defaultValue })
      // );
      setPayloadHotelService({ hotelServices: defaultValue })
      setSelectedHotelService(defaultValue)
    }
  }, [defaultValue])

  const handleItemsChange = (selected) => {
    setSelectedHotelServiceFullObject(selected)
    const data = selected?.map((data,index) => ({hotelServiceId:data.id, sequenceNo:index+1}))
    if(selected?.length>20){
      setSelectedHotelServiceMaxLengthError("Maximum 20 Hotel Services can be selected");
    }
    else{
      setSelectedHotelServiceMaxLengthError("");
    }
    setPreviewHotelService(selected)
    setSelectedHotelService(data)
  };

  const previewHandler = () => {
    if(selectedHotelService.length>20){
      setSelectedHotelServiceMaxLengthError("Maximum 20 Hotel Services can be selected");
      return;
    }
    // localStorage.setItem(
    //   "hotelServicesPayload",
    //   JSON.stringify({ hotelServices: selectedHotelService })
    // );
    setSelectedHotelServiceMaxLengthError("");
    setPayloadHotelService({ hotelServices: selectedHotelService })
    setHotelServiceData(selectedHotelService)
    setPreview(true);
  }

  const onSaveHandler = () => {
    if(selectedHotelService.length>20){
      setSelectedHotelServiceMaxLengthError("Maximum 20 Hotel Services can be selected");
      return;
    }
    // localStorage.setItem(
    //   "hotelServicesPayload",
    //   JSON.stringify({ hotelServices: selectedHotelService })
    // );
    setSelectedHotelServiceMaxLengthError("");
    setPayloadHotelService({ hotelServices: selectedHotelService })
    setHotelServiceData(selectedHotelService)
    // setPreview(true);
    const nextTab = tabs?.find((data)=>data?.railName==="hotelService")
    if(nextTab?.sequenceNo<5){
      tabChangeHandler(nextTab?.sequenceNo)
    }
    else{
      setPreview(true);
    }
  }

  return (
    <Fragment>
      <DualListBox
        listTitle="List Of Hotel Services"
        selectedListTitle="Selected Hotel Services"
        items={hotelServiceList}
        initialData={initialSelected}
        onChange={(selected) => handleItemsChange(selected)}
        selectedHotelServiceMaxLengthError={selectedHotelServiceMaxLengthError}
      />
      <div className="text-end">
        {editPublishUnPublish && <button
          onClick={onResetHotelService}
          type="button"
          className="create-btn ms-2"
        >
          Reset
        </button>}
        <button
          onClick={previewHandler}
          type="button"
          className="create-btn ms-2"
        >
          preview
        </button>
        <button
          onClick={onSaveHandler}
          type="button"
          className="create-btn ms-2"
        >
          {editPublishUnPublish ? "Update" : "Save"}
        </button>
      </div>
      {preview && (
        <BasicModal
          popupOpen={preview}
          bodyMessage={
            <RailConfigPreview
              setPreview={setPreview}
              // onSubmitHandler={onSubmitHandler}
              // editPublishUnPublish={editPublishUnPublish}
              previewListRowData={{ roomTypes, railName }}
              onCreateRailConfigPreview={true}
              tabs={tabs}
              onResetHandler={onResetHandler}
              previewUtilityData={selectedUtilityFullObject}
              previewPartnerData={selectedPartnerFullObject}
              previewChannelData={selectedChannelForYouFullObject}
              previewHotelServiceData={previewHotelService}
              previewHotelChannelData={selectedHotelChannelFullObject}
            />
          }
          popupSize={"col-11 rails-preview"}
          footer={{
            ...(editPublishUnPublish && {
              thirdButton: {
                buttonName: "Reset Rail",
                action: () => onResetHandler(),
              },
            }),
            primaryButton: {
              buttonName: `${editPublishUnPublish ? "Update" : "Create"} Rail`,
              action: () => onSubmitHandler(false),
            },
            secondaryButton: {
              buttonName: "Publish Rail",
              action: () => onSubmitHandler(true),
            },
          }}
          popBtnAlignment="justify-content-end"
        />
      )}
    </Fragment>
  );
}

export default HotelServices;
